import { render, staticRenderFns } from "./SimulationView.vue?vue&type=template&id=a5bdbbcc&"
import script from "./SimulationView.vue?vue&type=script&lang=js&"
export * from "./SimulationView.vue?vue&type=script&lang=js&"
import style0 from "./SimulationView.vue?vue&type=style&index=0&id=a5bdbbcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports